import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { multiPolygonSchema, polygonSchema } from "../geojson";
import { paginatedSchema } from "../pagination";

import { baseAssetSchema } from "./assetsBase";

export const polderListItemSchema = baseAssetSchema.extend({
  geometry: polygonSchema.or(multiPolygonSchema),
  name: z.string(),
});

export type PolderListItem = z.infer<typeof polderListItemSchema>;

export const polderListSchema = paginatedSchema(polderListItemSchema);
export type PolderList = z.infer<typeof polderListSchema>;

export const polderSchema = polderListItemSchema;
export type Polder = z.infer<typeof polderSchema>;

export function usePolders(params = {}) {
  const url = combineUrlAndParams("/api/v4/polders/", params);
  return useParsedQuery<PolderList>(
    ["lizard-api-v4", "polders", url],
    () => fetchWithError(url),
    (json: unknown) => polderListSchema.parse(json)
  );
}

export function usePolder(id: number) {
  return useParsedQuery<Polder>(
    ["lizard-api-v4", "polders", id],
    () => fetchWithError(`/api/v4/polders/${id}/`),
    (json: unknown) => polderSchema.parse(json)
  );
}

export function useMultiplePolders(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "polders", id],
        fetchFunction: () => fetchWithError(`/api/v4/polders/${id}/`),
        parseFunction: (json: unknown) => polderSchema.parse(json),
      };
    })
  );
}
